import { Box, Card, Typography, Button } from "@mui/material"
import parse from 'html-react-parser';
import { format } from 'timeago.js';
import Apiconfig from "../../../config/ApiConfig";
import DownloadIcon from '@mui/icons-material/Download';

export const DataCard = ({ data }) => {
    return (
        <>
            <Card sx={{ p: 2, borderRadius: '12px', border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    width="100%"
                >
                    <Typography sx={{ fontWeight: 600 }}>
                        Title : {data?.agenda}
                    </Typography>
                    <Typography color="text.secondary" variant="body2">
                        {format(data?.createdAt)}
                    </Typography>
                </Box>
                <Box my={1.5}>
                    <Typography variant="body2" color="text.primary">
                        {parse(`${data?.description}`)}
                    </Typography>
                </Box>
                {data.doc && (
                    <Box display='flex' justifyContent='flex-end' mt={1}>
                        <Button
                            component="a"
                            target="_blank"
                            href={`${Apiconfig.url}${data.doc}`}
                            variant="outlined"
                            color="secondary"
                            startIcon={<DownloadIcon />}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '8px',
                                fontWeight: 600,
                                px: 2,
                                py: 0.75,
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                }
                            }}
                        >
                            Download Document
                        </Button>
                    </Box>
                )}
            </Card>
        </>
    )
}
